import { styled } from '@mui/system';

const FlippedInRtlRoot = styled('div')(() => ({
    "[dir=rtl] &": {
        transform: 'scaleX(-1)'
    }
}));

const FlippedInRtl = ({ children }) => {
    return (
        <FlippedInRtlRoot>
            {children}
        </FlippedInRtlRoot>
    );
}

export default FlippedInRtl;
